var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information"},[_c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"广告费导入","name":"first"}},[_c('FeeImportAds')],1),_c('el-tab-pane',{attrs:{"label":"COD回款导入","name":"second"}},[_c('FeeImportCOD')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }